let navigation = {
  /*'dashboard': {
    name: 'Dashboard',
    to: '/',
    meta: {
      iconClass: "icon pe pe-7s-display1"
    }
  },*/
  'calendar': {
    name: 'calendar',
    to: [
    ],
    meta: {
      iconClass: "icon pe pe-7s-date"
    }
  },
  'bookings': {
    name: 'bookings',
    to: [],
    meta: {
      iconClass: "icon pe pe-7s-note2"
    }
  },
  'guestbook': {
    name: 'guestbook',
    new: "",
    to: [],
    meta: {
      iconClass: "icon pe pe-7s-notebook"
    }
  },
  'locks': {
    name: 'locks',
    to: [],
    meta: {
      iconClass: "icon pe pe-7s-door-lock"
    }
  },
  /*'prices': {
    name: 'prices',
    to: [],
    meta: {
      iconClass: "icon pe pe-7s-cash"
    }
  },*/
  'invoices': {
    name: 'invoices',
    to: [],
    meta: {
      iconClass: "icon pe pe-7s-ribbon"
    }
  },
  'reports': {
    name: 'reports',
    to: [],
    meta: {
      iconClass: "icon pe pe-7s-display1"
    }
  },
  'settings': {
    name: 'settings',
    to: "",
    meta: {
      iconClass: "icon pe pe-7s-settings"
    }
  },
  /*'dropdown': {
    name: 'Dropdown',
    to: [
      {
        name: 'Insula Apartment',
        to: '/',
        meta: {
          iconClass: "icon extra-bold",
          iconContent: "I A".match(/\b\w/g).join('').slice(0, 3).toUpperCase()
        },
      },
      {
        name: 'Soča Guesthouse',
        to: '/',
        meta: {
          iconClass: "icon extra-bold",
          iconContent: "S G".match(/\b\w/g).join('').slice(0, 3).toUpperCase()
        },
      },
      {
        name: "Nika's Tiny House",
        to: '/',
        meta: {
          iconClass: "icon extra-bold",
          iconContent: "N T H L S".match(/\b\w/g).join('').slice(0, 3).toUpperCase()
        },
      },
    ],
    meta: {
      iconClass: "icon pe pe-7s-display1"
    }
  }*/
};

/*{
  name: 'Soca Guesthouse',
  to: '/calendar/socaguesthouse',
  meta: {
    iconClass: "icon pe pe-7s-display1"
  }
}*/

export const navigationLinks = navigation;
